module.exports = __webpack_public_path__ + "img/announcement.f41eecd6.svg";